import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";
import Tapes from "./pages/Tapes";
import Editorial from "./pages/Editorial";
import RausAusDemFalschenLeben from "./pages/RausAusDemFalschenLeben";
import DerSong from "./pages/DerSong";
import BeASocialSeller from "./pages/BeASocialSeller";
import Inspiration from "./pages/Inspiration";
import Kontakt from "./pages/Kontakt";
import Downloads from "./pages/Downloads";
import Stimmen from "./pages/Stimmen";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import BuildZip from "./pages/BuildZip";
import StaticPage from "./pages/StaticPage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <HashRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Tapes />} />
            <Route path="/tapes" element={<Tapes />} />
            <Route path="/editorial" element={<Editorial />} />
            <Route path="/raus" element={<RausAusDemFalschenLeben />} />
            <Route path="/song" element={<DerSong />} />
            <Route path="/social-seller" element={<BeASocialSeller />} />
            <Route path="/inspiration" element={<Inspiration />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/stimmen" element={<Stimmen />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/build-zip" element={<BuildZip />} />
            <Route
              path="/presse"
              element={
                <StaticPage titleKey="presseTitle" testId="page-presse" />
              }
            />
            <Route
              path="/kontakt-info"
              element={
                <StaticPage
                  titleKey="kontaktTitle"
                  testId="page-kontakt-info"
                />
              }
            />
          </Routes>
        </HashRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
